import { formatCurrency } from '../../../../../../utils/currency';
export function formatVariationPrice(defaultVariationPrice, price) {
  var variationDifference = price - defaultVariationPrice;
  if (!variationDifference) {
    return '-';
  }
  if (variationDifference < 0) {
    return "(".concat(formatCurrency(variationDifference), ")");
  }
  return "(+".concat(formatCurrency(variationDifference), ")");
}